var productMappings = {};

function getDynamicCellEditor() {
  function dynamicEditor() { }
  dynamicEditor.prototype.init = function (params) {
    this.eGui = document.createElement('div');
    this.eGui.style =
      'height:100%;width:' + params.column.actualWidth + 'px';
    //Create and append select list
    this.selectEle = document.createElement('select');
    this.selectEle.style =
      'position:relative; height:100%;width:' +
      params.column.actualWidth +
      'px';
    this.selectEle.id = 'mySelect';
    this.selectEle.class = 'mySelect';

    this.selectEle = document.createElement('select');
    this.eGui.appendChild(this.selectEle);
    let defaultProducts = [params.node.data.product]
    if (params.value) { defaultProducts.push({ id: params.value, text: productMappings[params.value] }) }

    $(this.selectEle).selectize({   //<--- add selectize
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      items: [params.value || params.node.data.product.id],
      options: defaultProducts,
      maxItems: 1,
      preload: true,
      onItemAdd: function (value, $item) {
        productMappings[value] = $item.text()
      },
      render: {
        option: function (item, escape) {
          return `<div class="with-avatar">
              <div class="avatar avatar-s">
                <img src="${item.image}" />
              </div>
              <span>${item.text}</span>
            </div>`;
        }
      },
      load: function (query, callback) {
        $.ajax('/products/autocomplete_search', {
          type: 'get',
          data: {
            q: query
          },
          success: function (res) {
            callback(res);
          }
        })
      }
    });
  };
  dynamicEditor.prototype.getGui = function () {
    return this.eGui;
  };
  dynamicEditor.prototype.afterGuiAttached = function () {
    this.eGui.focus();
    // this.eGui.select();
  };
  dynamicEditor.prototype.getValue = function () {
    return this.selectEle.value;
  };
  dynamicEditor.prototype.destroy = function () { };
  dynamicEditor.prototype.isPopup = function () {
    return true;  //as popup
  };
  return dynamicEditor;
}

function numericCellEditor() {
  function numericEditor() { }
  numericEditor.prototype.init = function (params) {
    this.eGui = document.createElement('input');
    this.eGui.type = 'number'
    this.eGui.value = params.value;
    this.eGui.className = 'ag-cell-edit-input focus-visible'

  };
  numericEditor.prototype.getGui = function () {
    return this.eGui;
  };
  numericEditor.prototype.afterGuiAttached = function () {
    this.eGui.focus();
  };
  numericEditor.prototype.getValue = function () {
    return this.eGui.value;
  };
  numericEditor.prototype.destroy = function () { };
  return numericEditor;
}

window.SupplierGrid = {
  _grid: null,
  _gridOptions: {
    rowData: null,
    onGridReady(e) {
      return e.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    headerHeight: 44,
    rowHeight: 94,
    singleClickEdit: true,
    suppressPaginationPanel: true,
    animateRows: true,
    suppressRowClickSelection: true,
    toolPanelSuppressSideButtons: true,
    suppressContextMenu: true,
    stopEditingWhenGridLosesFocus: true,
    rowBuffer: 1000,
    domLayout: 'autoHeight',
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    rowClassRules: {
      'approved-product': function (params) { return params.data.state === 'approved'; },
      'rejected-product': function (params) { return params.data.state === 'rejected'; }
    },
    // getRowHeight: function(params) {
    //   // assuming 50 characters per line, working how how many lines we need
    //   return 18 * (Math.floor((params.data.specifications.length || 50) / 45) + 1);
    // },
    columnDefs: [
      {
        field: 'id',
        headerName: '#',
        width: 40,
        minWidth: 40,
        maxWith: 40,
        cellClass: 'super-small-text',
        suppressSizeToFit: true,
        valueGetter: "node.rowIndex + 1"
      },
      {
        field: 'product_requirement_id',
        headerName: 'Requirement Id',
        hide: true
      },
      {
        field: 'title',
        headerName: "Title",
        cellClass: 'bold-weight',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
      },
      {
        field: 'model_number',
        headerName: "Model",
        width: 100,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
      },
      {
        field: 'tags',
        headerName: "Tags",
        tooltipField: 'tags',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        cellRenderer(params) {
          if (params.data.tags === undefined || params.data.tags.trim() == "") { return; }
          tags = ""
          params.data.tags.split(",").forEach((tag) => { tags = tags.concat(`<div class='tag__item'>${tag}</div>`) })
          return tags
        }
        // onCellDoubleClicked: event => {
        //   return $('.ag-popup-editor').find('input').val(event.node.data.tags);
        // }
      },
      {
        field: 'image',
        headerName: "Image",
        width: 80,
        minWidth: 80,
        maxWith: 80,
        suppressSizeToFit: true,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        sortable: false,
        cellRenderer(params) {
          var resultElement = document.createElement("div");
          if (!params.value) {
            resultElement.className = 'image-input no-image'
          } else {
            var imageElement = document.createElement("img");
            imageElement.src = params.value;
            resultElement.appendChild(imageElement);
            resultElement.className = 'image-input'
          }
          return resultElement;
        }
      },
      {
        field: 'specifications',
        headerName: 'Specifications',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        width: 250,
        onCellValueChanged: params => {
          params.api.resetRowHeights();
        }
      },
      {
        field: 'company_product_id',
        headerName: "Proposed Product",
        editable: function (params) { return params.node.data.state != 'approved' },
        width: 220,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        cellEditor: "dynamicEditor",
        cellClassRules: {
          'errors': function (params) { return !params.node.data.company_product_id }
        },
        refData: productMappings
      },
      {
        field: 'price',
        headerName: "Price",
        width: 120,
        suppressSizeToFit: true,
        cellEditor: "numericEditor",
        editable: function (params) { return params.node.data.state != 'approved' },
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        cellClassRules: {
          'errors': function (params) { return params.value == null || params.value === "" }
        },
        valueFormatter(params) {
          if (params.value != null && params.value !== "") {
            value = Intl.NumberFormat('en-US', { style: 'currency', currency: params.data.currency, minimumFractionDigits: 0 }).format(params.value)
            if (params.data.unit) { value = value.concat(` / ${params.data.unit}`) }

            return value
          }
          else {
            placeholder = params.data.currency
            if (params.data.unit) { placeholder = placeholder.concat(` / ${params.data.unit}`) }

            return placeholder
          }
        }
      },
      {
        field: 'developer_note',
        headerName: "Note",
        editable: false,
        width: 70,
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        sortable: false,
        cellRenderer(params) {
          if (params.value) {
            return `<a id=${params.node.id} class='button small link no-height fas-sticky-note developer-note' href='javascript:;'>View</a>`
          }
        }
      },
    ],
    components: {
      dynamicEditor: getDynamicCellEditor(),
      numericEditor: numericCellEditor()
    }
  },

  _getRowHeightForSpecifications(params) {
    const specifications = params.data.specifications;
    const specificationsLines = Math.floor(specifications.length / 45) + 1;
    return (17 * specificationsLines) + 28;
  },

  initializeView(options, key) {
    if (options == null) { options = {}; }
    const gridDiv = document.getElementById('product-requirements-grid');

    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();

    if (options.action == 'show') {
      this._gridOptions.columnDefs.map(column => (column.editable = false))
    }

    options.data.requirements.forEach((element) => { productMappings[element.product.id] = element.product.text })

    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    if (options.data && options.data.requirements) {
      this._gridApi.setGridOption('rowData', options.data.requirements);
    }
    $(document).on('click', '.developer-note', _.bind(this._showNoteModal, this))
    resizeAgGridTable($('#product-requirements-grid')[0], this._gridOptions, 0, 5);
    this._resizeHorizontally();
    $(window).resize(_.bind(this._resizeHorizontally, this));

    $(document).on('submit', 'form#product-set-form', function (event) {
      var rowData = [];
      let error = false;

      SupplierGrid._gridOptions.api.forEachNode(function (node) {
        if (!!node.data.company_product_id && !node.data.price || (!node.data.company_product_id && !!node.data.price)) {
          error = true
        }

        rowData.push(_.pick(node.data, 'id', 'product_requirement_id', 'company_product_id', 'price'));
      });

      if (_.isEmpty(rowData) || error) {
        event.preventDefault()
        showFlashMessage(I18n.t('errors.0008'), 'alert')
        $('form#product-set-form button[type="submit"]').removeClass('processing');
        $('span.spinner').remove();
      }
      element = document.createElement('input')
      element.type = 'hidden'
      element.name = 'product_set[requirements_attributes]'
      element.value = JSON.stringify(rowData)
      $(this).append(element);
      return true;
    })
  },

  _resizeHorizontally() {
    return this._gridApi.sizeColumnsToFit();
  },

  _showNoteModal(event) {
    const $target = $(event.currentTarget);
    const row = SupplierGrid._gridOptions.api.getRowNode($target.prop('id'))
    $('.developer-note-modal').remove();
    $('body').append(`<div id="modal-${row.id}" class="reveal-modal small developer-note-modal" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog"> \
      <div class='panel-wrapper modal-header'> \
        <h3><i class='fal fas-sticky-note'></i>Requirement: ${row.data.title}</h3></div> \
      <div class='panel-wrapper modal-body'> \
        <div class='section-header'>Note from Buyer:</div>
        <div class='small-top-buffer'>${row.data.developer_note}</div></div> \
      <div class='panel-wrapper modal-footer'><button class='button small close-reveal-modal tertiary'>Close</button></div> \
    </div>`)
    return $(`#modal-${row.id}`).foundation('reveal', 'open');
  }
}
